import React from 'react';
import { Stack } from '@mui/material';

import { useMerchant } from '../../../contexts/MerchantContext';
import { CustomersTableHeader } from '../../../common/Customers/CustomersTableHeader';
import { CustomersTable } from '../../../common/Customers/CustomersTable';
import { useCustomersTable } from '../../../hooks/useCustomersTable';

const Customers = (): JSX.Element => {
  const { merchantId } = useMerchant();
  const { customerData, isLoading, tableParams, setTableParams, filterParams, setFilterParams } =
    useCustomersTable({ merchantId });

  return (
    <Stack gap={2} sx={{ mt: 4 }}>
      <CustomersTableHeader
        merchantId={merchantId}
        defaultSearchQuery={filterParams.searchQuery}
        onSearch={(query) => {
          setTableParams({ ...tableParams, pageNumber: 1 });
          setFilterParams({ ...filterParams, searchQuery: query });
        }}
        isFilteringByCardOnFile={filterParams.cardOnFile}
        onFilterByCardOnFile={(cardOnFile) => {
          setTableParams({ ...tableParams, pageNumber: 1 });
          setFilterParams({ ...filterParams, cardOnFile });
        }}
      />
      <CustomersTable
        customerData={customerData}
        isLoading={isLoading}
        tableParams={tableParams}
        setTableParams={setTableParams}
      />
    </Stack>
  );
};

export default Customers;
